import { Component } from '@angular/core';
import { AdminApprovedPhComponent } from "../../../../components/admin-dashboard-component/admin-approved-ph-component/admin-approved-ph-component";

@Component({
  selector: 'app-approved-ph-list',
  imports: [AdminApprovedPhComponent],
  templateUrl: './approved-ph-list.html',
  styleUrl: './approved-ph-list.scss'
})
export class ApprovedPhList {

}
